const Wrapper = ({ children }) => {
  return (
    <div className="max-w-screen-xl py-28 mx-auto px-4 text-center md:px-8">
      {children}
    </div>
  )
}

export default Wrapper
